import axios from 'axios';

const API_CONFIG = {
  // CATALOG_SERVICE: 'http://192.168.0.185:8081',
  // ORDER_SERVICE: 'http://192.168.0.185:8081',
  // AUTH_SERVICE: 'http://192.168.0.185:8081',

  CATALOG_SERVICE: 'https://backend.svmart.in',
  ORDER_SERVICE: 'https://backend.svmart.in',
  AUTH_SERVICE: 'https://backend.svmart.in',
};

const getAuthToken = () => {
  try {
    const savedUser = localStorage.getItem('svmart_user');
    if (savedUser) {
      const userData = JSON.parse(savedUser);
      return userData.token || userData.accessToken || userData.access_token || null;
    }
  } catch (error) {
    return null;
  }
  return null;
};

const createInstance = (baseURL, requiresAuth) => {
  const instance = axios.create({
    baseURL,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
  });

  instance.interceptors.request.use(
    async (config) => {
      if (requiresAuth) {
        const token = getAuthToken();
        if (token && config.headers) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        alert("Session expired. Please login again.");
        localStorage.removeItem('svmart_user');
        
        if (window.location.pathname !== '/login') {
          window.location.href = '/login';
        }
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

export const catalogApi = createInstance(API_CONFIG.CATALOG_SERVICE, false);
export const authApi = createInstance(API_CONFIG.AUTH_SERVICE, false);
export const authSecureApi = createInstance(API_CONFIG.AUTH_SERVICE, true);
export const orderApi = createInstance(API_CONFIG.ORDER_SERVICE, true);